var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-col',{staticClass:"col-no-left-pad",attrs:{"sm":"4"}},[_c('mdb-card',[_c('mdb-card-body',[_c('mdb-card-text',{attrs:{"id":"crdtxt"},domProps:{"innerHTML":_vm._s(_vm.twitter_feed)}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }